class Customer.FilterFolder extends Backbone.Model
  urlRoot: '/customer/filter_collections'

  defaults:
    type: 'folder'

  isFilter: ->
    false

  initialize: ->
    @set('children', @_childModels())
    @_bubbleUpEvents(child) for child in @get('children')

  _childModels: ->
    return [] unless @get('children')
    @_childModel(item) for item in @get('children')

  _childModel: (item) ->
    if item.query
      item.query = JSON.parse item.query
      new Customer.Filter(item)
    else
      new Customer.FilterFolder(item)

  _bubbleUpEvents: (child) ->
    @listenTo(child, 'destroy:filter', @_handleDestroyFilter)

  _handleDestroyFilter: (filter) =>
    @_removeFilter filter
    @trigger 'destroy:filter', filter

  _removeFilter: (filter) ->
    @set 'children', (child for child in @get('children') when child isnt filter)

  update: (callback) ->
    json = @toJSON()
    @save(json, {wait: true, success: (model, response, options) =>
      @set('id', response.folder.id)
      callback(@)
    })

  addChild: (child) ->
    @get('children').push child
    @_bubbleUpEvents child

  isNew: ->
    @get('id') in [undefined, null]

  isGlobal: ->
    _.isNull(@get('user_id'))

  getFilterCollectionId: ->
    parseInt(@get('filter_collection_id'))

  getOldFilterCollectionId: ->
    parseInt(@get('old_filter_collection_id'))

  firstLevel: ->
    _.isNull(@get('filter_collection_id'))

  secondLevel: ->
    !_.isNull(@get('filter_collection_id'))

  isRoot: ->
    @get('id') == 'private-filter' || @get('id') == 'public-filter'

  allFilters: ->
    _.flatten(child.allFilters() for child in @get('children'))

  getFilters: ->
    @allFilters()

  isOpen: ->
    @get('open')

  visibleFilters: ->
    return [] unless @isOpen()
    _.flatten(child.visibleFilters() for child in @get('children'))
